import { Flex, SimpleGrid, Text } from "@mantine/core";
import { useFormContext } from "react-hook-form";
import {
  IMaskInputControlled,
  TextInputControlled,
  SectionsForm,
  AcceptClientTerms,
} from "../../components";
import { IPostBuyNow } from "../../interfaces/PurchaseNow";
import { useTranslation } from "react-i18next";

const PurchaseStep1 = () => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<IPostBuyNow>();

  const acceptTerm = watch("user.term_of_contract");

  const handleAcceptTerm = () => {
    setValue("user.term_of_contract", !acceptTerm);
  };

  return (
    <SectionsForm
      title={t("marketplace.comprar_agora.purchase_step_1.title_section")}
      number={"01"}
    >
      <Flex direction="column" gap={"24px"}>
        <Flex w={"100%"} justify={"space-between"}>
          <Text
            fz={{ base: 24 }}
            fw={{ base: 600 }}
            lh={{ base: "37.2px" }}
            c={"basic.5"}
          >
            {t("marketplace.comprar_agora.purchase_step_1.title")}
          </Text>
        </Flex>

        <SimpleGrid
          cols={1}
          breakpoints={[{ minWidth: "991", cols: 2, spacing: "32px" }]}
        >
          <TextInputControlled
            name="user.name"
            label={t("global.input.name.label")}
            placeholder={t("global.input.name.placeholder")}
            withAsterisk
          />
          <IMaskInputControlled
            name="user.document_nr"
            label={t("global.input.document_nr.label")}
            placeholder="000.000.000-00"
            mask="000.000.000-00"
            withAsterisk
          />
          <TextInputControlled
            name="user.email"
            label={t("global.input.email.label")}
            placeholder={t("global.input.email.placeholder")}
            withAsterisk
          />
          <IMaskInputControlled
            name="user.cell_phone"
            label={t("global.input.cell_phone.label")}
            placeholder="(00) 00000-0000"
            mask="(00) 00000-0000"
            withAsterisk
          />
          <AcceptClientTerms
            acceptTerm={acceptTerm}
            handleAcceptTerm={handleAcceptTerm}
          />
        </SimpleGrid>
      </Flex>
    </SectionsForm>
  );
};
export default PurchaseStep1;
